import SBMO003Z from './SBMO-003Z.js';
import SBHT003C from './SBHT-003C.js';
import S4SW001P8EU from './S4SW-001P8EU.js';
import S4EM001PXCEU16 from './S4EM-001PXCEU16.js';
import S4EM001CXCEU63 from './S4EM-001CXCEU63.js';
import S4PL00416EU from './S4PL-00416EU.js';
import S4PL00415US from './S4PL-00415US.js';
import SNGWZW01 from './SNGW-ZW01.js';
import S4SW001X8EU from './S4SW-001X8EU.js';
import S4SW001P16EU from './S4SW-001P16EU.js';
import S4SW001X16EU from './S4SW-001X16EU.js';
import S4SN0A24X from './S4SN-0A24X.js';
import S4SN0D24X from './S4SN-0D24X.js';
import SBTR001AEU from './SBTR-001AEU.js';
import S4SN0071A from './S4SN-0071A.js';
import S4SN0071Z from './S4SN-0071Z.js';
import S4SW002P16EU from './S4SW-002P16EU.js';
import S4SW0A2X4EUL from './S4SW-0A2X4EUL.js';
import S4PL00116US from './S4PL-00116US.js';
import S4SN0U61X from './S4SN-0U61X.js';
import S4SW0A1X1EUL from './S4SW-0A1X1EUL.js';
import SPSW204PE16EU from './SPSW-204PE16EU.js';
import S4PB00CU000002 from './S4PB-00CU000002.js';
import SPSW001PE40EU from './SPSW-001PE40EU.js';
import S4DM0A102US from './S4DM-0A102US.js';
import S4DM0A101WWL from './S4DM-0A101WWL.js';
import S4EM003RXCEU63 from './S4EM-003RXCEU63.js';
import S4EM002CXCEU from './S4EM-002CXCEU.js';
import S4PL00114EU from './S4PL-00114EU.js';
import S4PL00116EU from './S4PL-00116EU.js';
import S4DM0010WW from './S4DM-0010WW.js';
import S4PB00C0187105 from './S4PB-00C0187105.js';
import S4PB06A7000101 from './S4PB-06A7000101.js';
import S4PB0916176901 from './S4PB-0916176901.js';
import S4SN0A61X from './S4SN-0A61X.js';

export const Gen4 = {
	'SBMO-003Z': SBMO003Z,
	'SBHT-003C': SBHT003C,
	'S4SW-001P8EU': S4SW001P8EU,
	'S4EM-001PXCEU16': S4EM001PXCEU16,
	'S4EM-001CXCEU63': S4EM001CXCEU63,
	'S4PL-00416EU': S4PL00416EU,
	'S4PL-00415US': S4PL00415US,
	'SNGW-ZW01': SNGWZW01,
	'S4SW-001X8EU': S4SW001X8EU,
	'S4SW-001P16EU': S4SW001P16EU,
	'S4SW-001X16EU': S4SW001X16EU,
	'S4SN-0A24X': S4SN0A24X,
	'S4SN-0D24X': S4SN0D24X,
	'SBTR-001AEU': SBTR001AEU,
	'S4SN-0071A': S4SN0071A,
	'S4SN-0071Z': S4SN0071Z,
	'S4SW-002P16EU': S4SW002P16EU,
	'S4SW-0A2X4EUL': S4SW0A2X4EUL,
	'S4PL-00116US': S4PL00116US,
	'S4SN-0U61X': S4SN0U61X,
	'S4SW-0A1X1EUL': S4SW0A1X1EUL,
	'SPSW-204PE16EU': SPSW204PE16EU,
	'S4PB-00CU000002': S4PB00CU000002,
	'SPSW-001PE40EU': SPSW001PE40EU,
	'S4DM-0A101WWL': S4DM0A101WWL,
	'S4DM-0A102US': S4DM0A102US,
	'S4DM-0010WW': S4DM0010WW,
	'S4EM-003RXCEU63': S4EM003RXCEU63,
	'S4EM-002CXCEU': S4EM002CXCEU,
	'S4PL-00114EU': S4PL00114EU,
	'S4PL-00116EU': S4PL00116EU,
	'S4PB-00C0187105': S4PB00C0187105,
	'S4PB-06A7000101': S4PB06A7000101,
	'S4PB-0916176901': S4PB0916176901,
	'S4SN-0A61X': S4SN0A61X,
};
